export default {
  moreNewsButton: "more news",
  title: "in other news"
};
